const defaultState = {
  system: {
    Locale: 'zh_CN'
  },
  header: {
    Logo: '../assets/logo.png'
  }
}

const state = defaultState

const getters = {
  System: state => {
    return state.system
  },
  Header: state => {
    return state.header
  }
}

const mutations = {
  INIT_UI(state, obj) {
    state = JSON.parse(JSON.stringify(defaultState))
  },
  SAVE_UI(state, obj) {
    state[obj.name] = JSON.parse(JSON.stringify(obj.content))
  }
}

const actions = {
  InitUI({ commit }, payload) {
    commit('INIT_UI', payload)
  },
  SaveUI({ commit }, payload) {
    commit('SAVE_UI', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
